import { render, staticRenderFns } from "./Patron.vue?vue&type=template&id=1c39d41c&scoped=true&"
import script from "./Patron.vue?vue&type=script&lang=js&"
export * from "./Patron.vue?vue&type=script&lang=js&"
import style0 from "./Patron.vue?vue&type=style&index=0&id=1c39d41c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39d41c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Hint: require('/home/bitrix/frontend/components/other/Hint.vue').default})
